import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styles: ['.pnf-logo { max-width: 35em; }']
})
export class PageNotFoundComponent {}
